import {connect} from 'react-redux';
import setJourneyStop from 'Data/actionCreators/journey/setJourneyStop';
import navigate from 'Data/actionCreators/kiosk/navigate';
import LocationPromotions from 'Components/layouts/kiosk/KioskLayout/LayoutComponents/Locations/LocationPromotions';

const mapStateToProps = state => ({
    digitalSignId: state.pageState.layout.config.digitalSignId,
});

export default connect(
    mapStateToProps,
    {
        navigate,
        setJourneyStop,
    }
)(LocationPromotions);
